var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrinfo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  width: 24,
  height: 24,
  rx: 6,
  fill: "#1D1B20"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 9V14",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 17,
  r: 1,
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrinfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/errinfo.5b819ad139f9a9509a83e736bc917fda.svg";